import LeadingAuthors from "./leading-authors";

export default LeadingAuthors;